import { useHomeText } from '../text';

const EducationalContents = () => {
  const t = useHomeText();
  return (
    <section id="contents" style={{ background: "#141C63", backgroundImage: "radial-gradient(rgba(255,255,255,0.12) 1.5px, transparent 1.5px)", backgroundSize: "44px 44px", color: "#FFFFFF" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "104px 24px", display: "flex", flexDirection: "column", gap: "44px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "center", textAlign: "center" }}>
          <span style={{ fontWeight: "700", color: "#46D3BE", fontSize: "16px" }}>
            {t.contents.learningContent}
          </span>
          <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2" }}>
            {t.contents.whatShallWeDo}
          </h2>
          <p style={{ margin: "0", fontSize: "18px", color: "#DCE0FF", maxWidth: "680px" }}>
            {t.contents.thisIsHowThe}
          </p>
        </div>
        <figure style={{ margin: "0", display: "flex", flexDirection: "column", alignItems: "center", gap: "28px" }}>
          <div style={{ position: "relative", width: "100%", maxWidth: "1120px" }}>
            <div aria-hidden="true" className="kh-pulse" style={{ position: "absolute", top: "10%", right: "8%", bottom: "10%", left: "8%", borderRadius: "50%", background: "radial-gradient(closest-side, rgba(70,211,190,0.38), rgba(70,211,190,0))", filter: "blur(30px)" }} />
            {" "}
            <div style={{ position: "relative", padding: "14px", borderRadius: "46px", background: "linear-gradient(160deg, #2B3598 0%, #0B1240 65%)", border: "1px solid rgba(255,255,255,0.16)", boxShadow: "0 40px 90px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.2)" }}>
              <span aria-hidden="true" style={{ position: "absolute", top: "50%", left: "5px", width: "5px", height: "64px", marginTop: "-32px", borderRadius: "5px", background: "rgba(255,255,255,0.22)" }} />
              {" "}
              <img width="2200" height="1015" loading="lazy" decoding="async" src="/assets/img/screen-home.webp" alt={t.contents.theKhotouaHomeScreenAlt} style={{ display: "block", width: "100%", height: "auto", borderRadius: "32px", background: "#1A2470" }} />
            </div>
          </div>
          <figcaption style={{ width: "100%", maxWidth: "1120px", display: "flex", flexDirection: "column", alignItems: "center", gap: "22px" }}>
            <ul aria-label={t.contents.homeScreenSpacesLabel} style={{ margin: "0", padding: "0", listStyle: "none", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "12px" }}>
              <li style={{ display: "inline-flex", alignItems: "center", gap: "10px", padding: "10px 16px", borderRadius: "16px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)" }}>
                <span aria-hidden="true" style={{ width: "12px", height: "12px", borderRadius: "50%", background: "#46D3BE", boxShadow: "0 0 0 4px #46D3BE33", flex: "none" }} />
                <strong style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "19px", color: "#46D3BE" }}>
                  {t.contents.myLessons}
                </strong>
                <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
                  {t.contents.arabicFrenchEnglishMaths}
                </span>
              </li>
              <li style={{ display: "inline-flex", alignItems: "center", gap: "10px", padding: "10px 16px", borderRadius: "16px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)" }}>
                <span aria-hidden="true" style={{ width: "12px", height: "12px", borderRadius: "50%", background: "#2CC7C2", boxShadow: "0 0 0 4px #2CC7C233", flex: "none" }} />
                <strong style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "19px", color: "#2CC7C2" }}>
                  {t.contents.myGames}
                </strong>
                <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
                  {t.contents.challengeAndCreativityAdventures}
                </span>
              </li>
              <li style={{ display: "inline-flex", alignItems: "center", gap: "10px", padding: "10px 16px", borderRadius: "16px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)" }}>
                <span aria-hidden="true" style={{ width: "12px", height: "12px", borderRadius: "50%", background: "#F27DC2", boxShadow: "0 0 0 4px #F27DC233", flex: "none" }} />
                <strong style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "19px", color: "#F27DC2" }}>
                  {t.contents.myEncyclopedia}
                </strong>
                <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
                  {t.contents.t3dInAugmentedReality}
                </span>
              </li>
              <li style={{ display: "inline-flex", alignItems: "center", gap: "10px", padding: "10px 16px", borderRadius: "16px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)" }}>
                <span aria-hidden="true" style={{ width: "12px", height: "12px", borderRadius: "50%", background: "#9BE15D", boxShadow: "0 0 0 4px #9BE15D33", flex: "none" }} />
                <strong style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "19px", color: "#9BE15D" }}>
                  {t.contents.myShop}
                </strong>
                <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
                  {t.contents.financialLiteracyLearningTo}
                </span>
              </li>
              <li style={{ display: "inline-flex", alignItems: "center", gap: "10px", padding: "10px 16px", borderRadius: "16px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)" }}>
                <span aria-hidden="true" style={{ width: "12px", height: "12px", borderRadius: "50%", background: "#FF9A4D", boxShadow: "0 0 0 4px #FF9A4D33", flex: "none" }} />
                <strong style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "19px", color: "#FF9A4D" }}>
                  {t.contents.myDiscoveries}
                </strong>
                <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
                  {t.contents.discoverAndLearnVideos}
                </span>
              </li>
            </ul>
          </figcaption>
        </figure>
      </div>
    </section>
  );
};

export default EducationalContents;
